// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  TelemetryStreamType,
  AggregateSpec,
  WindowSize,
  SequenceOpSpec,
  AggregateSpecV2,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  projectId: __t.u32().name("project_id"),
  name: __t.string(),
  description: __t.string(),
  inputStreamName: __t.string().name("input_stream_name"),
  get inputStreamType() {
    return TelemetryStreamType.name("input_stream_type");
  },
  get aggregate() {
    return AggregateSpec;
  },
  get window() {
    return WindowSize;
  },
  anchorOffsetMinutes: __t.i32().name("anchor_offset_minutes"),
  outputStreamName: __t.string().name("output_stream_name"),
  enabled: __t.bool(),
  lastFinalizedBucket: __t.option(__t.timestamp()).name("last_finalized_bucket"),
  droppedLateSamples: __t.u64().name("dropped_late_samples"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  get sequenceOp() {
    return __t.option(SequenceOpSpec).name("sequence_op");
  },
  seqStateA: __t.f64().name("seq_state_a"),
  seqStateB: __t.f64().name("seq_state_b"),
  seqInitialized: __t.bool().name("seq_initialized"),
  seqLastOutput: __t.f64().name("seq_last_output"),
  seqSkippedCorrections: __t.u64().name("seq_skipped_corrections"),
  get aggregateV2() {
    return __t.option(AggregateSpecV2).name("aggregate_v_2");
  },
});
